<div class="container-fluid">
  <app-page-header
    icon="fe-file-text"
    pretitle="Configurações"
    title="Modelos de e-mail"
    description="O que as mensagens automáticas dizem a quem participa."
  >
    <a actions class="btn btn-outline-light" routerLink="..">Voltar</a>
  </app-page-header>
</div>

<div class="container-fluid">
  @if (loading()) {
    <div class="card"><div class="card-body"><p class="text-muted mb-0">A carregar…</p></div></div>
  } @else {
    <div class="alert alert-light border d-flex align-items-start gap-2">
      <i class="fe fe-info"></i>
      <span>
        Cada modelo é escolhido pelo sistema conforme o caso — não há como enviar um à mão.
        Enquanto um modelo não for escrito aqui, sai o texto que vem com a aplicação.
      </span>
    </div>

    @if (error()) { <div class="alert alert-danger small py-2">{{ error() }}</div> }

    <div class="list-group mb-4">
      @for (template of templates(); track template.key) {
        <div class="list-group-item px-3 py-3">
          <div class="d-flex align-items-center gap-3">
            <span class="avatar avatar-sm">
              <span class="avatar-title fs-lg rounded"
                    [class.bg-success-soft]="template.customized"
                    [class.text-success]="template.customized"
                    [class.bg-secondary-soft]="!template.customized"
                    [class.text-secondary]="!template.customized">
                <i class="fe" [class.fe-edit-3]="template.customized" [class.fe-file-text]="!template.customized"></i>
              </span>
            </span>
            <div class="flex-grow-1 min-w-0">
              <span class="fw-bold d-block">{{ template.label }}</span>
              <span class="small text-muted d-block">{{ template.description }}</span>
              <span class="small d-block mt-1">
                @if (template.customized) {
                  <span class="badge bg-success-soft">Escrito aqui</span>
                  @if (template.version) { <span class="text-muted ms-2">Versão {{ template.version }}</span> }
                  @if (template.approvedAt) {
                    <span class="text-muted ms-2">· aprovado em {{ template.approvedAt | date: 'dd/MM/yyyy' }}</span>
                  }
                } @else {
                  <span class="badge bg-secondary-soft">Texto da aplicação</span>
                }
              </span>
            </div>
            <button class="btn btn-sm btn-white" (click)="toggle(template.key)">
              <i class="fe me-1" [class.fe-chevron-down]="open() !== template.key"
                 [class.fe-chevron-up]="open() === template.key"></i>
              {{ open() === template.key ? 'Fechar' : 'Escrever' }}
            </button>
          </div>

          @if (open() === template.key) {
            <div class="border-top mt-3 pt-3">
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label">Assunto</label>
                  <input class="form-control" [(ngModel)]="template.subject"
                         placeholder="Em branco usa o assunto da aplicação, que leva o identificador" />
                </div>
                <div class="col-12">
                  <label class="form-label">Texto <span class="text-danger">*</span></label>
                  <textarea class="form-control occ-prewrap" rows="14" [(ngModel)]="template.body"
                            placeholder="Escreva aqui o corpo da mensagem."></textarea>
                  <small class="form-text text-muted">
                    Marcadores disponíveis — escreva-os tal e qual, entre chavetas:
                  </small>
                  <div class="mt-1">
                    @for (chave of chaves(template); track chave) {
                      <span class="badge bg-light text-dark border me-1 mb-1" [title]="template.placeholders[chave]">
                        <code>{{ '{' + chave + '}' }}</code> — {{ template.placeholders[chave] }}
                      </span>
                    }
                  </div>
                </div>

                <!-- Versão e aprovação: estes textos têm peso legal e a aprovação tem de viver
                     com eles, não presa a quem fez o deploy. -->
                <div class="col-md-3">
                  <label class="form-label">Versão</label>
                  <input class="form-control" [(ngModel)]="template.version" placeholder="0.0" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Aprovado em</label>
                  <app-date-picker [(ngModel)]="template.approvedAt" />
                </div>
                <div class="col-md-5">
                  <label class="form-label">Aprovado por</label>
                  <input class="form-control" [(ngModel)]="template.approvedBy" placeholder="Nome de quem aprovou" />
                </div>
              </div>

              <!-- Ver antes de pôr em vigor: manda o que está no ecrã, com valores de exemplo. -->
              <div class="border-top mt-3 pt-3">
                <div class="row g-2 align-items-end">
                  <div class="col-md-6">
                    <label class="form-label small">Enviar um exemplo para</label>
                    <input class="form-control form-control-sm" type="email" [(ngModel)]="testTo"
                           placeholder="o.seu.email@exemplo.pt" />
                  </div>
                  <div class="col-md-6">
                    <button class="btn btn-sm btn-white" (click)="sendTest(template)"
                            [disabled]="testing() === template.key || !testTo.trim()">
                      <i class="fe fe-send me-1"></i>
                      {{ testing() === template.key ? 'A enviar…' : 'Enviar teste' }}
                    </button>
                    <span class="small text-muted d-block mt-1">
                      Vai o texto que está aqui, mesmo por guardar.
                    </span>
                  </div>
                </div>
                @if (testResult(); as resultado) {
                  @if (resultado.key === template.key) {
                    <div class="alert mt-2 mb-0 small py-2"
                         [class.alert-success]="resultado.sent" [class.alert-danger]="!resultado.sent">
                      {{ resultado.message }}
                    </div>
                  }
                }
              </div>

              <div class="d-flex justify-content-between align-items-center mt-3">
                <span class="small text-muted">
                  @if (template.updatedBy) { Última alteração por {{ template.updatedBy }}. }
                </span>
                <div class="d-flex gap-2">
                  @if (template.customized) {
                    <button class="btn btn-sm btn-white" (click)="askReset(template)"
                            [disabled]="saving() === template.key">
                      Repor o texto da aplicação
                    </button>
                  }
                  <button class="btn btn-sm btn-primary" (click)="save(template)"
                          [disabled]="saving() === template.key">
                    {{ saving() === template.key ? 'A guardar…' : 'Guardar' }}
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

@if (pendingReset(); as alvo) {
  <div class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,.4)">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Repor o texto da aplicação?</h4>
        </div>
        <div class="modal-body">
          <p class="mb-0">
            O texto escrito para <strong>{{ alvo.label }}</strong> é apagado e volta o que vem
            com a aplicação. Não há como o recuperar depois.
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-white" (click)="cancelReset()">Cancelar</button>
          <button class="btn btn-danger" (click)="confirmReset()">Repor</button>
        </div>
      </div>
    </div>
  </div>
}
